export const isActive = (services) => !!services && !!Object.keys(services).length;
